import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    searchEmptyState: string;
    searchEmptyStateQuery: (query: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Empty state title shown when no projects match the current search */
            searchEmptyState: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NoResultsMessage.searchEmptyState?c=as11diiqch87", defaultMessage: "No projects matching" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state text that displays the user's search query (wrapped in quotes) */
            searchEmptyStateQuery: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (query: string) => __intl__.intl().formatMessage({ id: "NoResultsMessage.searchEmptyStateQuery?c=aka6ziwjznm5", defaultMessage: "\"{query}\"" }, { query: query }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
